import { Component, OnInit, ViewChild, Input, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject } from 'rxjs';
import { AttributeService } from 'src/app/services/attribute.service';
import { Router } from '@angular/router';
import { getPageSize, ResourceAccess } from 'src/app/shared/utils/calsoft-validators';
import { ListColumn } from 'src/app/shared/list/list-column.model';
import { Constant } from 'src/app/constant/constant';
import { ROUTE_TRANSITION } from 'src/app/app.animation';
import { CommonService } from 'src/app/services/common.service';
import { SelectionModel } from '@angular/cdk/collections';
import { UntypedFormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LeadAttributeService } from 'src/app/services/leadAttribute.service';
import { DealsAttributeService } from 'src/app/services/deals-attribute.service';
import { ContactAttributeService } from 'src/app/services/contact-attribute.service';
import { PatientsAttributeService } from 'src/app/services/patients-attribute.service';
import { TaskAttributeService } from 'src/app/services/task-attribute.service';
import { CompanyAttributeService } from 'src/app/services/company-attribute.service';
import { CompaniesAttributeService } from 'src/app/services/companies-attribute.service';
import { EcryptServiceService } from 'src/app/services/ecrypt-service.service';
import { CrmBusinessEditComponent } from 'src/app/shared/crm-business-edit/crm-business-edit.component';
import { LoaderService } from 'src/app/services/loader.service';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { RestrictionComponent } from '../restriction-pop-up/restriction/restriction.component';
import { PropertyAttributeService } from 'src/app/services/property-attribute.service';

@Component({
  selector: 'calsoft-common-attribute',
  templateUrl: './common-attribute.component.html',
  styleUrls: ['./common-attribute.component.scss']
})
export class CommonAttributeComponent implements OnInit {

  rowLeft: string = "100";
  rowRight: string = "0";
  rowgap: string = "0px";
  isGridVisible: boolean = true;

  url = '';
  sanitizedUrl = '';
  protected _onDestroy = new Subject<void>();

  @Output() onConfirAttribute: EventEmitter<any> = new EventEmitter<any>();
  read: any = false;
  selectionAttribute: any = [];
  @Input() type: string = "'attribute'";

  @Input() entityTypeId: any = 4;

  @Input() title: string;

  @Input() route: any = '/attribute/add-edit-attribute';

  @Input() primaryTitle = 'Manage Attribute';

  @Input() setId: any;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  filterActive: boolean = false;
  sortParam: any = 'attributeId' + "," + Constant.Dsc;
  paginationDetail = new BehaviorSubject(
    {
      length: 10,
      pageIndex: 0,
      pageSize: 10
    });
  pageIndex: any;
  pageSize: number;
  pageList: any;
  spinner: boolean;
  search: any;
  configData: any;
  GridType: any;
  filterType: any = 1;
  currentRouterPath: any;
  attributeList: any = [];
  pageSizeValue: any;
  filterSelectObj = [
    // {
    //   name: 'CODE',
    //   property: 'attributeCode',
    //   type: 'text',
    //   position: 'firstValue',
    //   options: []
    // },
    {
      name: 'ATTRIBUTE LABEL',
      property: 'frontendLabel',
      type: 'text',
      position: 'secondValue',
      options: []
    },
    {
      name: 'FRONTEND INPUT',
      property: 'frontendInput',
      type: 'select',
      position: 'eighthValue',
      options: [{ viewValue: "Select", value: "select" },
      { viewValue: "Text Area", value: "textarea" },
      { viewValue: "Text", value: "text" },
      { viewValue: "Date", value: "date" },
      { viewValue: "Yes/No", value: "boolean" },
      { viewValue: "Multiple Select", value: "multiselect" },
      { viewValue: "Price", value: "price" },]
    },
  ]
  elements: any;
  resourcePrivilege: any;
  attributeRestrictionValue: any;
  attributeRestriction: boolean = false;
  serviceUrl: string;
  resourceAccessType: any;
  crmFormGroupService: any;
  textsysn: string;


  constructor(
    private attributeService: AttributeService,
    private commonService: CommonService,
    private router: Router,
    private snackBar: MatSnackBar,
    private leadAttributeService: LeadAttributeService,
    private dealsAttributeService: DealsAttributeService,
    private contactAttributeService: ContactAttributeService,
    private patientsAttributeService: PatientsAttributeService,
    private taskAttributeService: TaskAttributeService,
    private companiesAttributeService: CompaniesAttributeService,
    private propertyAttributeService: PropertyAttributeService,
    private dialog: MatDialog,
    private ecryptService: EcryptServiceService,
    private loaderService: LoaderService,
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });
  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }

  ngOnInit() {

    this.read = true;
    const encryptedConfig = localStorage.getItem('configSettingsData')

    if (encryptedConfig) {

      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedConfig);
        this.configData = JSON.parse(decrypted);
        this.GridType = this.configData.gridType;
        this.filterType = this.configData.filterType;

      } catch (err) {
        console.error("Error decrypting crmSettingsData", err);
      }
    }
    this.textsysn = "Sync";

    if (this.entityTypeId == 9) {
      this.serviceUrl = 'leadAttributeService'
    } else if (this.entityTypeId == 11) {
      this.serviceUrl = 'dealsAttributeService'
    } else if (this.entityTypeId == 10) {
      this.serviceUrl = 'contactAttributeService'
    } else if (this.entityTypeId == 12) {
      this.serviceUrl = 'patientsAttributeService'
    } else if (this.entityTypeId == 13) {
      this.serviceUrl = 'taskAttributeService'
    } else if (this.entityTypeId == 14) {
      this.serviceUrl = 'companiesAttributeService'
    } else if (this.entityTypeId == 15) {
      this.serviceUrl = 'propertyAttributeService'
    }
    else {
      this.serviceUrl = 'attributeService'
    }

    if (this.entityTypeId == 9) {
      this.resourceAccessType = ResourceAccess.MANAGELEADATTRIBUTE;
    } else if (this.entityTypeId == 11) {
      this.resourceAccessType = ResourceAccess.DEALSATTRIBUTES;
    } else if (this.entityTypeId == 10) {
      this.resourceAccessType = ResourceAccess.CONTACTATTRIBUTES;
    } else if (this.entityTypeId == 1) {
      this.resourceAccessType = ResourceAccess.PATIENTSATTRIBUTES;
    } else if (this.entityTypeId == 13) {
      this.resourceAccessType = ResourceAccess.TASKATTRIBUTES;
    } else if (this.entityTypeId == 14) {
      this.resourceAccessType = ResourceAccess.COMPANYATTRIBUTE;
    } else if (this.entityTypeId == 15) {
      this.resourceAccessType = ResourceAccess.PROPERTYATTRIBUTE;
    }
    else {
      this.resourceAccessType = ResourceAccess.ATTRIBUTE;
    }

    this.getResource();

  }
  create: any;

  getResource() {
    this.commonService
      .getAllAccessForResource(this.resourceAccessType)
      .subscribe((data: any) => {
        if (!data.read) {
          this.router.navigate(['/unauthorized']);
        } else {
          this.resourcePrivilege = data;
          this.read = data.read;
          this.create = data.create;

          if (!this.create && data.restriction.length > 0) {
            this.attributeRestriction = false;
          } else if (data.restriction.length > 0) {
            this.attributeRestrictionValue = data.restriction[0].attributeRestriction
            this.attributeRestriction = true;

          }
          this.getAttribute();

          if (this.type == 'product') {
            this.columns = [];

            this.columns = [
              { name: 'select', property: 'select', visible: true, isModelProperty: false },
              { name: 'Attribute Label', property: 'frontendLabel', visible: true, isModelProperty: true },
              { name: 'Frontend Input', property: 'frontendInput', visible: true, isModelProperty: true },
              { name: 'Action', property: 'actions', visible: true, disabled: true },
            ] as ListColumn[];
          } else {

          }
        }
      });
  }



  getAttribute() {
    this.filterActive = false;
    this.spinner = true;



    if (this.type != 'product') {


      this[this.serviceUrl].getAttribute(this.page, this.size, this.sortParam, this.entityTypeId).subscribe(
        res => {
          this.spinner = false;
          this.attributeList = new MatTableDataSource();
          this.elements = res['numberOfElements'];
          this.attributeList = res['content'];
          this.attributeList.sort = this.sort;
          this.attributeList.paginator = this.paginator;
          this.pageList = res['totalElements'];
          this.pageSizeValue = getPageSize(this.pageList);
        },
        error => {

          this.spinner = false;
        }
      )
    } else {

      this[this.serviceUrl].getAttributeConfigurable(this.setId, this.page, this.size, this.sortParam).subscribe(
        res => {
          this.spinner = false;
          this.attributeList = new MatTableDataSource();
          this.elements = res['numberOfElements'];
          this.attributeList = res['content'];
          this.attributeList.sort = this.sort;
          this.attributeList.paginator = this.paginator;
          this.pageList = res['totalElements'];
          this.pageSizeValue = getPageSize(this.pageList);
          this.checkBoxControl.reset();
          this.attributeListForProduct = [];
          this.selectionAttribute = [];
          this.onConfirAttribute.emit(this.attributeListForProduct);

        },
        error => {

          this.spinner = false;
        }
      )
      throw new Error('Method not implemented.');
    }

  }


  getUpdate(event) {
    this.paginationDetail.next(event);
    this.page = event.pageIndex;
    this.size = event.pageSize;
    this.DetectingRequestType();
  }


  sortData(event) {
    if (event.active != 'actions') {
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;
      this.sortParam = event.active;
      if (event.direction == 'asc') {
        this.sortParam = this.sortParam + "," + Constant.Asc;
      } else if (event.direction == 'desc') {
        this.sortParam = this.sortParam + "," + Constant.Dsc;
      }
      this.DetectingRequestType();
    }
  }

  DetectingRequestType() {
    if (!this.filterActive) {
      this.getAttribute();
    }
    else {
      this.filterOption(this.search);
    }
  }

  filterOption(event) {
    this.search = event;
    this.spinner = true;
    if (this.type != 'product') {
      this.filterActive = true;

      this.search = this.search + " AND entityTypeId:*" + this.entityTypeId + "*"
      this[this.serviceUrl].searchAttribute(this.search, this.page, this.size, this.sortParam).subscribe(
        res => {
          this.spinner = false;
          this.attributeList = res['content'];
          this.elements = res['numberOfElements'];
          this.pageList = res['totalElements'];
          this.pageSizeValue = getPageSize(this.pageList);
        },
        error => {

          this.spinner = false;
        })
    } else {
      this[this.serviceUrl].searchAttributeConfigurable(this.setId, this.search, this.page, this.size, this.sortParam).subscribe(
        res => {
          this.spinner = false;

          this.elements = res['numberOfElements'];
          this.attributeList = res['content'];
          this.attributeList.sort = this.sort;
          this.attributeList.paginator = this.paginator;
          this.pageList = res['totalElements'];
          this.pageSizeValue = getPageSize(this.pageList);

        },
        error => {

          this.spinner = false;
        }
      )
    }
  }


  @Input()
  columns: ListColumn[] = [
    // { name: 'select', property: 'select', visible: true, isModelProperty: false },
    { name: 'Attribute Label', property: 'frontendLabel', visible: true, isModelProperty: true },
    { name: 'Frontend Input', property: 'frontendInput', visible: true, isModelProperty: true },
    { name: 'Action', property: 'actions', visible: true, disabled: true },
  ] as ListColumn[];


  onFilterChange(value) {
    if (value == '') {
      this.getAttribute();
    } else {


      this.page = Constant.PAGE;
      this.size = Constant.SIZE;
      let searchTerm = null;
      if (this.type != 'product') {
        searchTerm = "attributeCode:'" + '*' + value.trim() + '*'
          + "'  OR frontendLabel:'" + '*' + value.trim() + '*'
          + "'    OR frontendInput:'" + '*' + value.trim() + '*'
          + "'    AND entityTypeId:'" + '*' + this.entityTypeId + '*'
          + "'  OR attributeId:'" + '*' + value.trim() + '*' + "' "
      } else {
        searchTerm = value.trim();
      }
      this.filterOption(searchTerm)
    }
  }

  applyFilter(filterValue: string) {
    this.attributeList.filter = filterValue.trim().toLowerCase();
  }

  addattribute() {
    if (this.attributeRestriction && this.pageList >= this.attributeRestrictionValue) {
      this.restritionPopup();
      return;
    } else {
      let attributeId = 0;
      this.router.navigate([`${this.route}/${attributeId}`])
    }

  }

  restritionPopup() {

    let dialogRef = this.dialog.open(RestrictionComponent, {
      width: '350px',
    });
  }

  editattribute(attributeId) {
    this.router.navigate([`${this.route}/${attributeId}`])
  }

  onFilterChangeColumn(i) {
    if (i == undefined) {
      this.filterActive = false
      this.getAttribute();
    } else {
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;
      this.filterOption(i)
    }
  }
  selection = new SelectionModel<any>(true, []);

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.attributeList.length;

    return numSelected === numRows;

  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :

      this.attributeList.forEach(row => this.selection.select(row.attributeId));

  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {

    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }


    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }


  public attributeIdList: any = [];
  public attributeListForProduct: any = [];
  // changeValue(isChecked: boolean,row) {


  //   if (isChecked) {
  //     this.attributeIdList.push(row.attributeId);
  //     this.attributeListForProduct.push(row.eavAttribute);

  //   } else {
  //     let indexForAttributeId = this.attributeIdList.findIndex(x => x.attributeId == row.attributeId)
  //     this.attributeIdList.splice(indexForAttributeId, 1);

  //     let index =  this.attributeListForProduct.findIndex(x => x.attributeId == row.attributeId)
  //     this.attributeIdList.splice(indexForAttributeId, 1);
  //     this.attributeListForProduct.splice(index, 1);

  //   }

  //   this.onConfirAttribute.emit(this.attributeListForProduct);
  // }
  checkBoxControl: UntypedFormControl = new UntypedFormControl();
  changeValue(isChecked: boolean, row) {



    if (isChecked) {
      // this.attributeIdList=[];
      // this.attributeListForProduct=[];
      let indexForSelection = this.selectionAttribute.findIndex(x => x.attributeId == row.attributeId)

      if (indexForSelection < 0) {
        this.selectionAttribute.push(row.attributeId);
        this.attributeIdList.push(row.attributeId);
        this.attributeListForProduct.push(row.eavAttribute);
        this.checkBoxControl.patchValue(row.attributeId)
      }

    } else {
      let indexForAttributeId = this.attributeIdList.findIndex(x => x.attributeId == row.attributeId)
      this.attributeIdList.splice(indexForAttributeId, 1);
      let indexForAttributeListForProduct = this.attributeIdList.findIndex(x => x.attributeId == row.attributeId)
      this.attributeListForProduct.splice(indexForAttributeListForProduct, 1);

      let indexForSelection = this.selectionAttribute.findIndex(x => x.attributeId == row.attributeId)
      this.selectionAttribute.splice(indexForSelection, 1);


    }

    this.onConfirAttribute.emit(this.attributeListForProduct);
  }

  // condition: string;
  // s:any;
  // filter = new Map<any, any>();
  // filterMap = new Map<any, any>();
  // changeValue(event,row){
  //   this.condition = null;

  //   this.s = row.attributeCode+"_s";
  //   if (event.checked) {
  //     if (this.filterMap.get(this.s) == undefined) {
  //       this.filterMap.set(this.s, event.source.value);
  //     } else {
  //       this[this.s] = this.filterMap.get(this.s) + "#" + event.source.value;

  //       this.filterMap.set(this.s, this[this.s]);
  //     }


  //   } else {
  //     this.condition = this.filterMap
  //       .get(this.s)
  //       .replace(event.source.value, "");

  //     let index = this.condition.length - 1;

  //     if (this.condition[index] == "#") {
  //       this.condition = this.condition.substring(0, index);

  //       this.filterMap.set(this.s, this.condition);
  //     } else if (this.condition.length == 0) {
  //       this.filterMap.delete(this.s);
  //     } else {
  //       this.filterMap.set(this.s, this.condition);
  //     }

  //     if (
  //       this.filterMap.get(this.s) != undefined &&
  //       this.filterMap.get(this.s).charAt(0) == "#"
  //     ) {
  //       this.condition = this.filterMap.get(this.s).slice(1);
  //       this.filterMap.set(this.s, this.condition);
  //     }
  //     if (this.filterMap.size != 0) {

  //     } else {

  //     }
  //   }
  // }


  deleteAllAttributeId(id: any) {
    this.spinner = true;
    this[this.serviceUrl].deleteByAttributId(id).subscribe(
      response => {
        this.spinner = false;
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.getAttribute()
        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      error => {
        this.spinner = false;
      })

  }
  isAtStart = true;
  isAtEnd = false;
  @ViewChild('stepsWrapper') stepsWrapper!: ElementRef<HTMLDivElement>;

  checkScrollPosition(): void {
    const { scrollLeft, scrollWidth, clientWidth } = this.stepsWrapper.nativeElement;
    this.isAtStart = scrollLeft === 0;
    // Check if we are at the end (with a small tolerance for fractional pixels)
    this.isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1;
  }

  scroll(direction: 'left' | 'right'): void {
    const element = this.stepsWrapper.nativeElement;

    const scrollAmount = element.clientWidth * 0.8;

    if (direction === 'left') {
      element.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      element.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }

    setTimeout(() => this.checkScrollPosition(), 500);
  }

  setupSteps: any[] = [
    // { id: 1, icon: 'auto_awesome', label: 'Personalize your CRM', status: 'active' },
    // { id: 2, icon: 'download', label: 'Import Lead', status: 'pending' },
  ];

  previousValues: { [key: string]: any } = {};

  onStepClick(step: any) {
    if (step.label === 'Personalize your CRM') {
      this.openBusinessEditDialog();
    }
  }

  openBusinessEditDialog(): void {
    if (this.dialog.openDialogs.length > 0) {
      return; // Don't open again
    }
    if (window.innerWidth > 768) {
      const dialogRef = this.dialog.open(CrmBusinessEditComponent, {
        width: '800px',
        panelClass: 'business-edit-dialog',
      });

      dialogRef.afterClosed().subscribe(result => {

        if (result && result['event'] == 'add') {
          window.location.reload();
          console.log("here dialog close");

        }
      });
    } else {

      const dialogRef = this.dialog.open(CrmBusinessEditComponent, {
        minWidth: '100vw', height: '100vh',
        panelClass: '',
      });

      dialogRef.afterClosed().subscribe(result => {

        if (result && result['event'] == 'add') {
          window.location.reload();

        }
      });

    }

  }


  editingCell: { rowId: any; colProperty: string } | null = null;

  editingElement: any = null;
  editingCol: any = null;

  refresh() {

    this.loaderService.show();
    this.onFilterChangeColumn(undefined)
    this.clearValue();

    this.loaderService.hide();

  }

  clearValue() {
    this.editingCell = null;
    this.editingElement = null;
    this.editingCol = null;
    let url = this.router.url;
    let cleanUrl = url.split('?')[0];
    localStorage.removeItem(cleanUrl);
    localStorage.removeItem(cleanUrl + "se"); localStorage.removeItem(cleanUrl + "select");
    localStorage.removeItem(cleanUrl + "type");
    localStorage.removeItem(cleanUrl + "range");
    localStorage.removeItem("advanceFilterConditionsText");
    localStorage.removeItem("advanceFilterEnble");
    localStorage.removeItem("advanceFilterConditions");

  }

  isFilterPanelOpen = false;
  isFilterPanelColumnOpen = false;

  toggleFilterPanel(): void {
    if (window.innerWidth <= 768) {
      this.isGridVisible = false;
    }

    this.isFilterPanelOpen = !this.isFilterPanelOpen;

    if (this.isFilterPanelOpen) {
      this.isFilterPanelColumnOpen = false;
      this.rowLeft = "70";
      this.rowRight = "30";
      this.rowgap = "16px";
      if (window.innerWidth <= 768) {
        this.rowRight = "100";
        this.rowLeft = "0";
      }
    } else {
      this.rowLeft = "100";
      this.rowRight = "0";
      this.rowgap = "0px";
      if (window.innerWidth <= 768) {
        this.isGridVisible = true;
      }
    }
  }

  toggleFilterColumnPanel(): void {
    if (window.innerWidth <= 768) {
      this.isGridVisible = false;
    }

    this.isFilterPanelColumnOpen = !this.isFilterPanelColumnOpen;

    if (this.isFilterPanelColumnOpen) {
      this.isFilterPanelOpen = false;
      this.rowLeft = "70";
      this.rowRight = "30";
      this.rowgap = "16px";
      if (window.innerWidth <= 768) {
        this.rowRight = "100";
        this.rowLeft = "0";
      }
    } else {
      this.rowLeft = "100";
      this.rowRight = "0";
      this.rowgap = "0px";
      if (window.innerWidth <= 768) {
        this.isGridVisible = true;
      }
    }
  }

  viewMode: 'compact' | 'comfortable' = 'compact';

  setView(mode: 'compact' | 'comfortable') {
    this.viewMode = mode;
  }

  closePopupTwo(event) {
    if (event == true) {
      this.toggleFilterColumnPanel();
    }

  }

  closePopupNew(event) {
    if (event == true) {
      this.toggleFilterPanel();
    }
  }

  isMobile = false;

  checkScreen() {
    this.isMobile = window.innerWidth <= 768; // adjust breakpoint as needed
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobile = window.innerWidth <= 768;
    if (!this.isMobile) {
      this.isGridVisible = true;
    }
  }

  trackByProp = (_: number, col: ListColumn) => col.property;


  closeEdit(leadId, key, value, element) {

    const backup = this.previousValues[key];

    element[key] = backup;

    this.clearValue()
  }

  backupValue(key: any, element: any) {
    this.previousValues[key] = element[key];

  }

  startEdit(rowId: any, colProperty: string, element: any, col: any) {

    const fieldMeta = this.filterSelectObj.find(f => f.property === colProperty);

    this.backupValue(colProperty, element);

    if (fieldMeta) {
      col.inputType = fieldMeta.type || 'text';
      col.options = fieldMeta.options || [];
    } else {
      col.inputType = 'text';
      col.options = [];
    }

    this.editingCell = { rowId, colProperty };
    this.editingElement = element;
    this.editingCol = col;
  }

  saveEdit(rowId: number, colProperty: string, newValue: any, element: any) {
    this.editingCell = null;

    let payload = { ...element };

    payload.operationType = "Change";

    payload[colProperty] = newValue;

    this.crmFormGroupService.addOrEditDistributor(payload).subscribe(
      (response) => {
        if (response['status_code'] === Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(
            response['status_message'] || "Updated successfully",
            '×',
            { panelClass: 'success', verticalPosition: 'bottom', duration: 1000 }
          );

          element[colProperty] = newValue;
        } else {
          this.snackBar.open(
            response['status_message'] || "Update failed",
            '×',
            { panelClass: 'error', verticalPosition: 'bottom', duration: 2000 }
          );
        }
      },
      (err) => {
        this.snackBar.open("Server error while updating", '×', {
          panelClass: 'error',
          verticalPosition: 'bottom',
          duration: 2000
        });
      }
    );
  }
} 